import { useEffect, useState } from "react";
import { getConnectionRuntimeConfigDetail } from "../services/connectionRuntimeConfig";

interface IuseFetchConnectionRuntimeConfigById {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  currentConnectionRuntimeConfigId: any;
}

const useFetchConnectionRuntimeConfigById = ({
  setIsLoading,
  currentConnectionRuntimeConfigId,
}: IuseFetchConnectionRuntimeConfigById) => {
  const [connectionRuntimeConfigData, setConnectionRuntimeConfigData] =
    useState<any>({});
  useEffect(() => {
    setIsLoading(true);
    const getConnectionRuntimeConfigData = async () => {
      try {
        const result =
          currentConnectionRuntimeConfigId > 0 &&
          (await getConnectionRuntimeConfigDetail({
            currentConnectionRuntimeConfigId,
          }));
        setConnectionRuntimeConfigData(result);
      } catch (err) {
        setConnectionRuntimeConfigData({});
      } finally {
        setIsLoading(false);
      }
    };
    getConnectionRuntimeConfigData();
  }, [currentConnectionRuntimeConfigId]);

  return [connectionRuntimeConfigData];
};

export default useFetchConnectionRuntimeConfigById;

